import React from 'react';
import { BuyButton } from './ui/BuyButton';
export function FinalCta() {
  return <section className="w-full bg-sage-800 px-5 py-20 sm:px-8 lg:py-28" data-id="element-41" data-mp="vffvgpvh26si">
      <div className="mx-auto max-w-2xl text-center" data-id="element-42" data-mp="vhiufzelra9d">
        <p className="flex items-center justify-center gap-3 text-[11px] font-semibold uppercase tracking-overline text-gold-200" data-id="element-43" data-mp="19g0bjea05oib">
          <span className="h-px w-7 bg-gold-400/50" aria-hidden="true" data-id="element-44" data-mp="15c2gpfrpmzv2" />
          Start today
          <span className="h-px w-7 bg-gold-400/50" aria-hidden="true" data-id="element-45" data-mp="1jbai8fbcik2f" />
        </p>
        <h2 className="mt-5 font-serif text-[2.4rem] leading-[1.04] text-cream sm:text-5xl lg:text-[3.5rem]" data-id="element-46" data-mp="1edipjj2vmtx6">
          Today you can start creating something{' '}
          <span className="italic text-gold-200" data-id="element-47" data-mp="1o3bqlq5e7qn6">beautiful with real flowers</span>
        </h2>
        <p className="mx-auto mt-6 max-w-xl text-[16px] leading-relaxed text-sage-100" data-id="element-48" data-mp="22338w32xzt6z">
          With the right method, pressed flower art stops being{' '}
          <strong className="font-semibold text-cream" data-id="element-49" data-mp="1x2gmeopkl5vn">trial and error</strong> and
          becomes a relaxing, creative habit full of possibilities.
        </p>
        <div className="mt-10 flex flex-col items-center gap-3" data-id="element-50" data-mp="s5qmrs84yys3">
          <BuyButton size="xl" variant="gold" label="Get the Complete Guide" className="w-full sm:w-auto" data-id="element-51" data-mp="x41xs6a63fbw" />
          <p className="text-[12.5px] text-sage-200" data-id="element-52" data-mp="1246dhu394612">
            Digital guide · instant download
          </p>
        </div>
      </div>
    </section>;
}